import moment from "moment";
import momentTz from "moment-timezone";
import get from "lodash/get";
import { getToken } from "../firebase";

export function toDateTimeStr(date) {
  return moment(date).format("MM-DD-YYYY HH:mm");
}
export function toDateTimeStrCEST(date) {
  return momentTz.tz(date, "Europe/Berlin").format("MM-DD-YYYY HH:mm");
}

export function toDateStr(date) {
  return moment(date).format("MM-DD-YYYY");
}

export function toTimeStr(date) {
  return moment(date).format("HH:mm");
}

export function currencyStr(numericVal) {
  return Math.round(numericVal);
}

export function generateDeviceToken() {
  return getToken();
}

export function handlingResponseError(e) {
  if (get(e, "response.data.error")) {
    return get(e, "response.data.error");
  }
  return e;
}

export function isInvalidName(string) {
  const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if(format.test(string)){
    return true;
  }
  if((/\d/.test(string))) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// client/lib/Utils.js